export const COUNTRIES = [
  {
    code: 'AU',
    name: 'Australia',
    regions: [
      'Australian Capital Territory',
      'New South Wales',
      'Northern Territory',
      'Queensland',
      'South Australia',
      'Tasmania',
      'Victoria',
      'Western Australia',
    ],
  },
];

export const getRegionsForCountry = (countryName: string): string[] => {
  const country = COUNTRIES.find((c) => c.name === countryName);
  return country ? country.regions : [];
};
